import { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import axiosInstance from '../../services/axios/axios';
import { WrapImsPacket } from '../../store/utility';
import * as utils from '../../utils';
import Profile from './components/Profile';
import UARLayout from './containers/Layout';
import classes from './UserAccessReview.module.scss';
import { UAR_CONSTANTS } from './util/constants';
import AccountDetailData from './components/AccountDetailData';

const AccountDetails = props => {
	/**
	 * Extract needed variables from the props provided by the `Scaffold`
	 */
	const {
		dispatch,
		loggedInUser,
		error,
		errorMessage,
		loading,
		setLoading,
		profileDetails,
		profileApplications,
		profileMobileDevices,
		profileBadges,
		profileServiceAccounts,
		canPerformActions,
		bulkSelections,
	} = props;
	//STATE

	let history = useHistory();

	/**
	 *
	 */
	const [appModifications, setAppModifications] = useState({});

	const queryParams = new URLSearchParams(props?.location?.search || '');
	const prefillAppId = Number(queryParams.get('appId'));
	const prefillAction = queryParams.get('action');
	const hasValidPrefill =
		Number.isFinite(prefillAppId) &&
		prefillAppId > 0 &&
		(prefillAction === UAR_CONSTANTS.APPLICATION_MODIFY ||
			prefillAction === UAR_CONSTANTS.APPLICATION_REVOKE);

	/**
	 *
	 */
	const [trackingNumber, setTrackingNumber] = useState(null);

	const [profile, setProfile] = useState({
		details: {},
		applications: [],
		mobileDevices: [],
		badges: [],
		serviceAccounts: [],
	});
	const { applications, mobileDevices, badges, serviceAccounts } = profile;

	useEffect(() => {
		setProfile(profile => {
			return { ...profile, details: profileDetails };
		});
	}, [profileDetails]);

	useEffect(() => {
		setProfile(profile => {
			return { ...profile, applications: profileApplications };
		});
	}, [profileApplications]);

	useEffect(() => {
		if (
			hasValidPrefill &&
			Array.isArray(profileApplications) &&
			profileApplications.length > 0
		) {
			const appToPrefill = profileApplications.find(app => {
				return app.id === prefillAppId;
			});

			if (appToPrefill) {
				setAppModifications(currentAppModifications => {
					if (
						currentAppModifications[prefillAppId] &&
						currentAppModifications[prefillAppId].action === prefillAction
					) {
						return currentAppModifications;
					}

					return {
						...currentAppModifications,
						[prefillAppId]: {
							action: prefillAction,
							data: appToPrefill,
						},
					};
				});
			}
		}
	}, [hasValidPrefill, prefillAction, prefillAppId, profileApplications]);

	useEffect(() => {
		setProfile(profile => {
			return { ...profile, mobileDevices: profileMobileDevices };
		});
	}, [profileMobileDevices]);

	useEffect(() => {
		setProfile(profile => {
			return { ...profile, badges: profileBadges };
		});
	}, [profileBadges]);

	useEffect(() => {
		setProfile(profile => {
			return { ...profile, serviceAccounts: profileServiceAccounts };
		});
	}, [profileServiceAccounts]);

	//FUNCTIONS
	const modifyHandler = appId => {
		appCartHandler(appId, UAR_CONSTANTS.APPLICATION_MODIFY);
	};

	const revokeHandler = appId => {
		appCartHandler(appId, UAR_CONSTANTS.APPLICATION_REVOKE);
	};

	const removeFromCartHandler = appId => {
		const newAppModifications = { ...appModifications };
		if (newAppModifications[appId]) {
			delete newAppModifications[appId];
		}
		setAppModifications(newAppModifications);
	};

	const appCartHandler = (appId, action) => {
		const newAppModifications = { ...appModifications };
		if (newAppModifications[appId]) {
			if (newAppModifications[appId].action === action) {
				delete newAppModifications[appId];
			} else {
				newAppModifications[appId].action = action;
			}
		} else {
			newAppModifications[appId] = {
				action: action,
				data: applications.filter(app => {
					return app.id === appId;
				})[0],
			};
		}
		setAppModifications(newAppModifications);
	};

	const resetCart = () => {
		setAppModifications({});
	};

	const proceedToCheckoutHandler = () => {
		const payload = {
			loggedInUser: loggedInUser.loggedInUser,
			target: profileDetails,
			apps: Object.values(appModifications),
		};
		axiosInstance
			.post(
				'/api/UserAccessReview/AppCart/Reserve',
				WrapImsPacket(payload)
			)
			.then(response => {
				switch (response.status) {
					case 200:
						if (response.data.responseCode) {
							const responseCode = response.data.responseCode;
							let data = response.data.payload;
							switch (responseCode) {
								case 200:
									if (data) {
										setTrackingNumber(data);
									}
									break;
								default:
									break;
							}
						}
						break;

					default:
						break;
				}
			})
			.catch(error => {
				// setError(true);
			});
	};

	const modifyAndValidateHandler = () => {
		const payload = {
			loggedInUser: loggedInUser.loggedInUser,
			targets: [profileDetails],
		};

		setLoading(true);
		axiosInstance
			.post('/api/UserAccessReview/Validation', WrapImsPacket(payload))
			.then(response => {
				switch (response.status) {
					case 200:
						if (response.data.responseCode) {
							const responseCode = response.data.responseCode;
							switch (responseCode) {
								case 200:
									setLoading(false);
									history.push(
										'/RRS/Request_ModifyDetail_View.aspx?tn=' +
											trackingNumber
									);
									break;
								default:
									setLoading(false);
									break;
							}
						}
						break;

					default:
						setLoading(false);
						break;
				}
			})
			.catch(errors => {
				setLoading(false);
			});
	};

	//RENDER

	const layout = (
		<UARLayout
			title={'Account Details'}
			loading={loading}
			error={error}
			errorMessage={errorMessage}
			canPerformActions={true}
		>
			<div
				className={utils.concatenateClassNames(
					['profile-page__container'],
					classes
				)}
			>
				<Profile
					details={profileDetails}
					navigation={
						profileDetails &&
						!profileDetails.isServiceAccount &&
						canPerformActions
					}
				/>
				<AccountDetailData
					dispatch={dispatch}
					loggedInUser={loggedInUser}
					error={error}
					errorMessage={errorMessage}
					loading={loading}
					canPerformActions={canPerformActions}
					appModifications={appModifications}
					trackingNumber={trackingNumber}
					proceedToCheckoutHandler={proceedToCheckoutHandler}
					removeFromCartHandler={removeFromCartHandler}
					resetCart={resetCart}
					modifyHandler={modifyHandler}
					revokeHandler={revokeHandler}
					modifyAndValidateHandler={modifyAndValidateHandler}
					profile={profile}
					setProfile={setProfile}
					applications={applications}
					mobileDevices={mobileDevices}
					badges={badges}
					serviceAccounts={serviceAccounts}
					bulkSelections={bulkSelections}
					readOnly={false}
				/>
			</div>
		</UARLayout>
	);

	return layout;
};

export default AccountDetails;
